@if (display) {
<div class="dialog" (click)="onClose()">
    <div class="item" [ngStyle]="style" (click)="onStop($event)">
        <ng-container [dynamic]="consent()"></ng-container>
    </div>
</div>
}
